// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3QMUP","ranges":"BmiRanges_ranges__HxfOI"};